$.fn.secondaryNavigation = function (options) {
  var defaults = {
    container: 'secondary-navigation__list',
    itemClass: 'secondary-navigation__item',
    linkClass: 'secondary-navigation__link',
    selector: '[data-navigation-id]'
  };
  var o = $.extend({}, defaults, options);
  var items = $(o.selector);
  var itemList = [];
  items.each(function() {
    var name = $(this).data('navigationName');
    var id = $(this).data('navigationId');
    itemList.push({ name: name, id: id });
  });
  var htmlString = '<ul class="' + o.container + '">';
  itemList.forEach(function(item) {
    var currentURL = window.location.origin + window.location.pathname; // získání aktuální URL bez parametrů a kotvy
    htmlString += '<li class="' + o.itemClass + '"><a class="' + o.linkClass + '" href="' + currentURL + '#' + item.id + '">' + item.name + '</a></li>';
  });
  htmlString += '</ul>';
  $(this).html(htmlString);
  return false;
};


// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/third/jquery.secondaryNavigation.js